export default "__VITE_ASSET__Dx7BOljq__"